import React from 'react';
import { Card, Typography, Divider } from 'antd';
import './About.less';

const { Title, Paragraph, Text } = Typography;

const About: React.FC = () => {
  return (
    <div className="about-container">
      <Card className="about-card">
        <Title level={3}>React TypeScript 应用</Title>
        <Divider />
        <Paragraph>
          这是一个使用 React、TypeScript 和 Ant Design 构建的现代化应用程序。
          本应用展示了如何使用最新的前端技术栈构建一个完整的 Web 应用。
        </Paragraph>
        <Paragraph>
          <Text strong>主要功能：</Text>
        </Paragraph>
        <ul className="feature-list">
          <li>首页列表展示，包含用户信息和内容</li>
          <li>响应式设计，适配各种设备</li>
          <li>现代化的用户界面</li>
          <li>使用 TypeScript 确保类型安全</li>
          <li>路由导航系统</li>
        </ul>
        <Divider />
        <Paragraph>
          <Text type="secondary">
            技术栈：React 18、TypeScript、React Router 6、Ant Design 5
          </Text>
        </Paragraph>
      </Card>
    </div>
  );
};

export default About;